import { render, staticRenderFns } from "./modalUploadCategoryMedia.vue?vue&type=template&id=3ccc982b&"
import script from "./modalUploadCategoryMedia.vue?vue&type=script&lang=js&"
export * from "./modalUploadCategoryMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports